import React from 'react';
import { Paper } from '@mui/material';

export default function InfoCardContentWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <Paper
      sx={{
        borderRadius: 0,
      }}
    >
      {children}
    </Paper>
  );
}
